import PropTypes from 'prop-types';
import React from 'react';
import logo from './../../../assets/logo.png';

import * as styles from './Logo.less';

const Logo = ({ size = 'small' }) => (
  <>
    {size == 'small' && <div className={styles.logo}>C</div>}
    {size == 'large' && (
      <img src={logo} className={styles.logoLarge} alt='Copytesting' />
    )}
  </>
);

Logo.propTypes = {
  size: PropTypes.string,
};

export default Logo;



// WEBPACK FOOTER //
// ./src/views/components/Logo/Logo.js